import { PRICE_GRIDS_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: PRICE_GRIDS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkPriceGrids'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/priceGrids/index.js